"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyOverridesToRate = void 0;
const models_1 = require("./models");
const rate_override_filterer_1 = require("./rate-override-filterer");
function applyOverridesToRate(options, rate, overrides) {
    const applicableOverrides = rate_override_filterer_1.filterRateOverrides(options, overrides);
    return applicableOverrides.reduce((overrideRate, rule) => {
        return applyOverrideToRate(options, overrideRate, rule);
    }, rate);
}
exports.applyOverridesToRate = applyOverridesToRate;
function applyOverrideToRate(options, rate, override) {
    return override.valueOverrides.reduce((overrideRate, valueOverride) => (Object.assign(Object.assign({}, overrideRate), { [valueOverride.field]: getOverrideValue(rate, valueOverride) })), rate);
}
function getOverrideValue(rate, valueOverride) {
    if (valueOverride.value.source === models_1.RateOverrideValueSource.Value) {
        return valueOverride.value.value;
    }
    return rate[valueOverride.value.value];
}
//# sourceMappingURL=apply-overrides-to-rate.js.map